import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { differenceInCalendarDays } from "date-fns";
import moment from "moment";
import { TransfereService } from "src/app/providers/transfer/transfer.service";
import { AppsService } from "src/app/shared/services/apps.service";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

// Our demo infrastructure requires us to use 'file-saver-es'. We recommend that you use the official 'file-saver' package in your applications.
// SECURITY (audit finding #9 - Formula Injection, CWE-1236)
import { sanitizeExcelCell } from "src/app/shared/utils/sanitize-export";

am4core.useTheme(am4themes_animated);
@Component({
  selector: "app-wards-coverage-ulb-dashboard",
  templateUrl: "./wards-coverage-ulb-dashboard.component.html",
  styleUrls: ["./wards-coverage-ulb-dashboard.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class WardsCoverageUlbDashboardComponent {
  /** Stable bound reference for <app-data-grid [cellPrepared]>. */
  bound_onCellPrepared = (e: any) => this.onCellPrepared(this.columnDefs, e);

  value;
  clntDtls: any;
  rdrctUlbDtls;
  tntLst: any = [];
  selectedtenant: any;
  selectedtenantNm: any;
  ulb_id: any;
  userDtls: any;
  tdyCoveredTrips: any[];
  showLdr: boolean;
  curDate;
  slctdDt = new Date();
  today = new Date();
  dateFormat = "dd/MM/yyyy";
  dbrd_ky = "ULB";
  tripsData: any[];
  columnDefs: any = [];
  rowselected: any;
  curYr: string;
  toptripsData: any = [];
  topTripscolumnDefs: any = [];
  ttlColumnDefs: any[];
  cvrge_prcnt: number;
  avg_cvrg: string;
  rdrctTrpDtls;
  tntCheck: any[];
  constructor(
    public apiServ: AppsService,
    public TransfereService: TransfereService,
    public route: Router
  ) {
    this.rdrctUlbDtls = [];
    this.clntDtls = JSON.parse(localStorage.getItem("wto_clients"));
    this.rdrctUlbDtls = this.TransfereService.getLoclData("ulbDta");
    this.rdrctTrpDtls = this.TransfereService.getLoclData("trpDta");
    this.clntDtls[0].tnts.forEach((element) => {
      this.tntLst.push(element);
    });
    if (this.rdrctUlbDtls) {
      this.ontntSelect(this.rdrctUlbDtls.tnt_id);
      this.slctdDt = this.rdrctUlbDtls.slctdDt;
    } else {
      this.selectedtenant = this.tntLst[0].tnt_id;
      this.selectedtenantNm = this.tntLst[0].tnt_dsply_nm;
    }
    this.userDtls = JSON.parse(localStorage.getItem("wto_w_user"));
    if (this.userDtls.rle_id == 37) {
      console.log(this.clntDtls);
      this.rowselected = {
        tnt_id: this.userDtls.tnt_id,
        slctdDt: new Date(),
        svm_apfs_cd: this.clntDtls[0].svm_apfs_cd,
        svm_id: this.clntDtls[0].svm_id,
      };
      this.TransfereService.setLoclData("svmDta", this.rowselected);
      this.route.navigate([`internal/dashboard/wardVehtripCvrge-dashboard`]);
    }
  }
  disabledDate = (current: Date): boolean => {
    // Can not select days before today and today
    return differenceInCalendarDays(current, this.today) > 0;
  };
  ngOnInit(): void {
    this.curYr = moment(this.today).format("YYYY");
    this.getCoveredTripsCount();
    this.getTripsData();
    setTimeout(() => {
      this.get_lst7DaysDistanceDta();
    }, 1000);

    this.getTop5Trips();
  }
  ontntSelect(value) {
    if (value == 0) {
      this.selectedtenant = 0;
      this.selectedtenantNm = "All ULB's Selected";
      this.ulb_id = 0;
    }
    for (let i = 0; i < this.tntLst.length; i++) {
      console.log("in");
      if (this.tntLst[i].tnt_id == value) {
        this.selectedtenant = this.tntLst[i].tnt_id;
        this.selectedtenantNm = this.tntLst[i].tnt_dsply_nm;
        // console.log(this.selectedtenant,this.selectedtenantNm  )
      }
    }
    this.setulbdta(value);
    this.getCoveredTripsCount();
    this.getTripsData();
    this.get_lst7DaysDistanceDta();
    this.getTop5Trips();
  }

  setulbdta(value) {
    this.rdrctTrpDtls.forEach((val) => {
      if (value == val.tnt_id) {
        this.TransfereService.ClearLocalData("ulbDta");
        this.TransfereService.setLoclData("ulbDta", val);
      }
    });
  }

  onChange(e): void {
    this.slctdDt = e;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.getCoveredTripsCount();
    this.getTripsData();
    this.get_lst7DaysDistanceDta();
    this.getTop5Trips();
  }
  getCoveredTripsCount(): any {
    this.tdyCoveredTrips = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/wards/getCoveredTripsCount/${this.dbrd_ky}`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.tdyCoveredTrips = res["data"];
        }
        this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  getTripsData() {
    // this.tntCheck = [2000006, 2000008, 2000009, 2000011, 1000101, 2000005, 2000010, 2000007]
    this.tripsData = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    this.ttlColumnDefs = [];
    this.columnDefs = [];
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/wards/ulb/getCoveredTripsDetails`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.tripsData = res["data"];
          console.log(this.tripsData);

          this.cvrge_prcnt = 0;
          let length = 0;
          this.tripsData.forEach((e) => {
            if (e.coverage_per && e.coverage_per != "NA") {
              this.cvrge_prcnt += parseFloat(e.coverage_per);
              length++;
            }
          });
          // var len=this.tripsData.filter(e=>e.coverage_per>0).length;
          // this.avg_cvrg = len > 0 ? (this.cvrge_prcnt / len).toFixed(2) : '0';
          this.avg_cvrg =
            length > 0 ? (this.cvrge_prcnt / length).toFixed(2) : "0";
          // const checkCondition = this.tntCheck.every(tntId => {
          //   return this.clntDtls[0].tnts.some(tnt => tnt.tnt_id === tntId);
          // })
          // console.log(checkCondition)
          // if (checkCondition) {
          this.columnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 50,
              filter: false,
              fixed: true,
            },
            // { headerName: 'ULB', field: 'clnt_nm', alignment: 'left', fixed: true },
            // { headerName: 'Sachivalayam', field: 'svm_nm', alignment: 'left', fixed: true },
            {
              headerName: "Zone",
              field: "ZONE",
              alignment: "left",
              fixed: true,
            },
            {
              headerName: "Vehicles Registration Number",
              field: "VEHICLES",
              alignment: "center",
            },
            // { headerName: 'Total Trips', field: 'TOTAL_TRIPS', alignment: 'center' },
            // { headerName: 'Completed Trips', field: 'OPERATED', alignment: 'center' },
            // { headerName: 'Started Trips(Running)', field: 'STARTED_TRIP', alignment: 'center' },
            // { headerName: 'Route Deviated', field: 'ROUTE_DEVIATED', alignment: 'center', width: 150 },
            {
              headerName: "Travle Distance(KM)",
              field: "dist",
              alignment: "center",
            },
            {
              headerName: "Coverage %",
              field: "coverage_per",
              alignment: "left",
            },
          ];
          // }
          // else {
          //   this.columnDefs = [
          //     { headerName: 'S.No', field: 'sno', alignment: 'center', width: 50, filter: false, fixed: true },
          //     { headerName: 'ULB', field: 'ZONE', alignment: 'left', fixed: true },
          //     // { headerName: 'Sachivalayam', field: 'svm_nm', alignment: 'left', fixed: true },
          //     { headerName: 'Zone', field: 'asrt_grp_nm', alignment: 'left', fixed: true },
          //     { headerName: 'Vehicles', field: 'vehct', },
          //     { headerName: 'Total Trips', field: 'TOTAL_TRIPS',  alignment: 'center' },
          //     { headerName: 'Completed Trips', field: 'OPERATED',  alignment: 'center' },
          //     { headerName: 'Started Trips', field: 'STARTED_TRIP', },
          //     { headerName: 'Route Deviated', field: 'ROUTE_DEVIATED', },
          //     { headerName: 'Travle Distance(KM)', field: 'dist', },
          //     { headerName: 'Coverage %', field: 'coverage_per', },
          //   ]
          // }
        }
        this.showLdr = false;
        this.ttlColumnDefs = [
          {
            headerName: "Vehicles",
            field: "vehct",
            alignment: "Center",
            summaryType: "sum",
          },
          // { headerName: 'Total Trips', field: 'TOTAL_TRIPS', alignment: 'Center', summaryType: 'sum' },
          // { headerName: 'Completed Trips', field: 'OPERATED', alignment: 'Center', summaryType: 'sum' },
          // { headerName: 'Started Trips(Running)', field: 'STARTED_TRIP', alignment: 'Center', summaryType: 'sum' },
          // { headerName: 'Route Deviated', field: 'ROUTE_DEVIATED', alignment: 'Center', summaryType: 'sum' },
          {
            headerName: "Travel Distance",
            field: "dist",
            alignment: "Center",
            summaryType: "sum",
            format: { type: "fixedPoint", precision: 2 },
          },
          {
            headerName: "Coverage %",
            field: "coverage_per",
            alignment: "Center",
            summaryType: "avg",
            format: { type: "fixedPoint", precision: 2 },
            customizeText: function (data) {
              return data.value !== null && data.value !== undefined
                ? data.value.toFixed(2) + "%"
                : "0.00%";
            },
          },
        ];
      },
      (err) => {
        // console.log(err);
      }
    );
  }
  onCellPrepared(colDef, e) {
    if (
      e.rowType === "data" &&
      e.row.data &&
      e.column.dataField == "VEHICLES"
    ) {
      e.cellElement.style.color = "rgb(0 142 255)";
      e.cellElement.style.fontWeight = 500;
      e.cellElement.style.borderRadius = "10px";
      e.cellElement.style.cursor = "pointer";
    }
  }
  devCellclk(devclmns, dvclkent) {
    console.log(dvclkent);
    if (dvclkent.columnIndex == 2) {
      if (dvclkent.data.VEHICLES != undefined) {
        this.rowselected = dvclkent.data;
        this.rowselected.slctdDt = this.slctdDt;
        console.log(this.rowselected);
        this.TransfereService.setLoclData("svmDta", this.rowselected);
        this.route.navigate([`internal/dashboard/wardVehtripCvrge-dashboard`]);
      }
    }
  }
  // lst7DayDstnc;
  get_lst7DaysDistanceDta(): any {
    let chart = am4core.create("coverageChart", am4charts.XYChart);
    chart.data = [];
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/wards/trpsCvrgeLast7Days/${this.dbrd_ky}`;
    this.apiServ.post(postslctdDt, rte).subscribe((res) => {
      chart.data = res["data"];
      console.log(chart.data);

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "dt";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = -45;
      categoryAxis.title.text = ` ----- Date(${this.curYr})----- `;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

      valueAxis.title.text = " ----- Covered % ----- ";
      chart.colors.list = [
        am4core.color("#f7babd"),
        // am4core.color("#7d64c4"),
      ];
      function createSeries(field, name) {
        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.valueY = field;
        series.dataFields.categoryX = "dt";
        series.name = name;
        series.columns.template.tooltipText =
          "{name} in {categoryX}: [bold]{valueY}[/]";
        series.columns.template.fillOpacity = 0.8;
        series.columns.template.height = am4core.percent(100);
        series.sequencedInterpolation = false;

        let columnTemplate1 = series.columns.template;
        columnTemplate1.strokeWidth = 1;
        let valueLabel = series.bullets.push(new am4charts.LabelBullet());
        valueLabel.label.text = "{valueY}";
        valueLabel.label.fontSize = 15;
        valueLabel.label.dy = 10;
        columnTemplate1.column.cornerRadiusTopLeft = 5;
        columnTemplate1.column.cornerRadiusTopRight = 5;
        columnTemplate1.strokeOpacity = 1;

        let categoryLabel = series.bullets.push(new am4charts.LabelBullet());
      }

      createSeries("coverage_per", "Coverage");
    });
  }
  getTop5Trips() {
    this.toptripsData = [];
    this.showLdr = true;
    this.curDate = moment(this.slctdDt).format("YYYY-MM-DD");
    var postslctdDt = {
      dt: this.curDate,
      slctd_tnt: this.selectedtenant,
    };
    let rte = `dashboard/enterprise/wards/getTop5Coverages/${this.dbrd_ky}`;
    this.apiServ.post(postslctdDt, rte).subscribe(
      (res) => {
        if (res["status"] == 200) {
          this.toptripsData = res["data"];

          this.topTripscolumnDefs = [
            {
              headerName: "S.No",
              field: "sno",
              alignment: "center",
              width: 50,
              filter: false,
            },
            { headerName: "ULB", field: "ZONE", alignment: "left", width: 200 },
            {
              headerName: "Zone",
              field: "asrt_grp_nm",
              alignment: "left",
              width: 200,
            },
            {
              headerName: "Coverage %",
              field: "coverage_per",
              alignment: "Center",
              width: "auto",
            },
          ];
        }
        this.showLdr = false;
      },
      (err) => {
        // console.log(err);
      }
    );
  }

  // onExporting1() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.

  // onExporting2() removed with the <app-data-grid> conversion: it was the
  // canonical exportDataGrid({ customizeCell: sanitizeExcelCell }) block, now
  // done by DataGridComponent.exportExcel() and sanitised at the addRow() sink.

  goBack() {
    this.TransfereService.ClearLocalData("ulbDta");
    this.TransfereService.ClearLocalData("trpDta");
    this.route.navigate([`internal/dashboard/wrdCvrge-dashboard`]);
  }
}
